import { Injectable } from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ThaiDateFormatterService extends NgbDateParserFormatter {
  override parse(value: string): NgbDateStruct | null {
    if (!value) return null;
    const parts = value.trim().split(' ');
    if (parts.length === 3) {
      const day = +parts[0];
      const month = this.getMonthFromThai(parts[1]);
      const year = +parts[2] - 543;
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        return { day, month, year };
      }
    }
    return null;
  }

  override format(date: NgbDateStruct | null): string {
    if (!date) return '';
    const year = date.year + 543;
    return `${date.day} ${this.getMonthInThai(date.month)} ${year}`;
  }

  private getMonthInThai(month: number): string {
    const shortMonths = [
      '',
      'ม.ค.',
      'ก.พ.',
      'มี.ค.',
      'เม.ย.',
      'พ.ค.',
      'มิ.ย.',
      'ก.ค.',
      'ส.ค.',
      'ก.ย.',
      'ต.ค.',
      'พ.ย.',
      'ธ.ค.',
    ];
    return shortMonths[month];
  }

  private getMonthFromThai(month: string): number {
    const map: { [key: string]: number } = {
      'ม.ค.': 1,
      'ก.พ.': 2,
      'มี.ค.': 3,
      'เม.ย.': 4,
      'พ.ค.': 5,
      'มิ.ย.': 6,
      'ก.ค.': 7,
      'ส.ค.': 8,
      'ก.ย.': 9,
      'ต.ค.': 10,
      'พ.ย.': 11,
      'ธ.ค.': 12,
    };
    return map[month] || 1;
  }
}
